module.exports = __webpack_public_path__ + "static/media/amulet_04.7cc7764e.png";